/* eslint-disable max-len */
/* eslint-disable guard-for-in */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { change, reduxForm } from 'redux-form';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { Container, Col, Row } from 'reactstrap';
import resourceServices from '../../../../../redux/services/resourceServices';
import LeftSide from './CoursePlanLeft';
import RightSide from './CoursePlanRight';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 'auto',
  },
  cardHeader: {
    padding: theme.spacing(1, 2),
  },
  list: {
    height: 500,
    backgroundColor: theme.palette.background.paper,
    overflow: 'auto',
  },
  button: {
    margin: theme.spacing(10, 5),
    fontSize: '40px',
  },
}));

const not = (a, b) => a.filter((value) => b.indexOf(value) === -1);

const intersection = (a, b) => a.filter((value) => b.indexOf(value) !== -1);

const union = (a, b) => [...a, ...not(b, a)];

const removeItemFromLeft = (list, elements) => {
  for (let j = 0; j < elements.length; j += 1) {
    let i = 0;
    while (i < list.length) {
      if (list[i] === elements[j].resourceId) {
        list.splice(i, 1);
      } else {
        i += 1;
      }
    }
  }

  return (list);
};

const CoursePlanTraining = (props) => {
  const [loaded, setLoaded] = useState(false);
  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);
  const [optionLabel, setOptionLabel] = useState([]);
  const [categorie, setCategorie] = useState([]);

  const [suggested, setSuggested] = useState({});

  const classes = useStyles();
  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const refreshCat = (leftArray, optLabel) => {
    const keys = [];
    const newOpt = {};
    for (const elem in leftArray) {
      if (!keys.includes(optLabel[leftArray[elem]].type)) keys.push(optLabel[leftArray[elem]].type);
      newOpt[leftArray[elem]] = {
        value: leftArray[elem],
        label: optLabel[leftArray[elem]].label,
        id: leftArray[elem],
        type: optLabel[leftArray[elem]].type,
      };
    }
    const finalGroup = [];
    keys.forEach((key, index) => {
      const finalGroupCat = [];
      for (const property in newOpt) {
        if (newOpt[property].type === key) {
          finalGroupCat.push({
            id: property,
            name: newOpt[property].label,
          });
        }
      }
      const group = {
        id: `cat-${index}`,
        name: `Categorie ${key}`,
        state: { expanded: true },
        children: finalGroupCat,
      };
      finalGroup.push(group);
    });
    setCategorie(finalGroup);
  };

  const getLeft = async () => {
    const data = await resourceServices.getAll();
    const optionsWithLabel = {};

    let options = [];
    const cat = [];
    await data.forEach((element) => {
      if (!cat.includes(element.type)) cat.push(element.type);
      optionsWithLabel[element._id] = {
        value: element._id, label: element.name, id: element._id, type: element.type,
      };
      return options.push(element._id);
    });

    if (props.dataform && props.dataform.values.resources
      && props.dataform.values.resources.length > 0) {
      const tmpRight = props.dataform.values.resources;
      const newRight = [];
      const tmpSuggest = {};
      options = removeItemFromLeft(options, tmpRight);

      for (let j = 0; j < tmpRight.length; j += 1) {
        newRight.push(tmpRight[j].resourceId);
        tmpSuggest[tmpRight[j].resourceId] = tmpRight[j].suggested;
      }
      setRight(newRight);
      setSuggested(tmpSuggest);
    } else if (props.dataform && props.dataform.initial.resources
      && props.dataform.initial.resources.length > 0) {
      const tmpRight = props.dataform.initial.resources;
      const newRight = [];
      const tmpSuggest = {};
      options = removeItemFromLeft(options, tmpRight);
      for (let k = 0; k < tmpRight.length; k += 1) {
        newRight.push(tmpRight[k].resourceId);
        tmpSuggest[tmpRight[k].resourceId] = tmpRight[k].suggested;
      }
      setRight(newRight);
      setSuggested(tmpSuggest);
    }

    setOptionLabel(optionsWithLabel);
    refreshCat(options, optionsWithLabel);
    setLeft(options);
    setLoaded(true);
  };

  useEffect(() => {
    getLeft();
  }, []);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    refreshCat(not(left, leftChecked), optionLabel);
    setChecked(not(checked, leftChecked));

    const finRes = [];
    const rightElem = right.concat(leftChecked);
    for (const elem in rightElem) {
      finRes.push({
        resourceId: rightElem[elem],
        suggested: suggested[rightElem[elem]] !== undefined ? suggested[rightElem[elem]] : false,
      });
    }
    props.dispatch(change(`${props.form}`, 'resources', finRes));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    refreshCat(left.concat(rightChecked), optionLabel);
    setChecked(not(checked, rightChecked));
    const finRes = [];
    const rightElem = not(right, rightChecked);
    for (const elem in rightElem) {
      finRes.push({
        resourceId: rightElem[elem],
        suggested: suggested[rightElem[elem]] !== undefined ? suggested[rightElem[elem]] : false,
      });
    }
    props.dispatch(change(`${props.form}`, 'resources', finRes));
  };

  const changeTree = (event) => {
    const tmpCat = [...categorie];

    for (let i = 0; i < tmpCat.length; i += 1) {
      if (tmpCat[i].id === event) tmpCat[i].state.expanded = !tmpCat[i].state.expanded;
    }

    setCategorie(tmpCat);
  };

  if (loaded) {
    return (
      <Container className="group-creation-container-centered">
        <Row style={{ marginTop: '20px', width: '100%' }}>
          <Col style={{ padding: '1px' }} md={5}>
            <LeftSide data={{
              handleToggleAll,
              numberOfChecked,
              handleToggle,
              changeTree,
              left,
              categorie,
              checked,
              classes,
            }}
            />
          </Col>
          <Col
            md={2}
            style={{
              flex: 1,
              flexDirection: 'column',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Button
              variant="outlined"
              size="small"
              className={classes.button}
              onClick={handleCheckedRight}
              disabled={leftChecked.length === 0}
              aria-label="move selected right"
            >
              &gt;
            </Button>
            <Button
              variant="outlined"
              size="small"
              className={classes.button}
              onClick={handleCheckedLeft}
              disabled={rightChecked.length === 0}
              aria-label="move selected left"
            >
              &lt;
            </Button>
          </Col>
          <Col md={5}>
            <RightSide data={{
              handleToggleAll,
              numberOfChecked,
              handleToggle,
              setRight,
              setSuggested,
              checked,
              optionLabel,
              suggested,
              right,
              classes,
            }}
            />
          </Col>

        </Row>
      </Container>
    );
  }
  return (<div />);
};

CoursePlanTraining.defaultProps = {
  dataform: [],
};

CoursePlanTraining.propTypes = {
  dataform: PropTypes.array,
  dispatch: PropTypes.any.isRequired,
  form: PropTypes.any.isRequired,
};

function mapStateToProps(state) {
  const name = `group_${state.group.selectedGroup._id}`;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];
  return { initialValues: state.group.selectedGroup, form: name, dataform };
}

const connectedGroupForm = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
})(injectIntl(CoursePlanTraining));

const NewconnectedGroupForm = connect(mapStateToProps, {})(connectedGroupForm);

export default NewconnectedGroupForm;
